(function() {
    'use strict';

    angular
        .module('ipmApp')
        .factory('SurveyResponseSearch', SurveyResponseSearch);

    SurveyResponseSearch.$inject = ['$resource'];

    function SurveyResponseSearch($resource) {
        var resourceUrl =  'api/_search/survey-responses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
